/**
 * Typography CSS Rules Generator
 *
 * Function for generating CSS rules from typography control values
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { applyFilters } from '@wordpress/hooks';

import type { TypographyValues } from '../types';

/**
 * Generate typography CSS rules from TypographyValues
 */
export const generateTypographyCSSRules = (
	values: TypographyValues,
): Record< string, string > => {
	const styles: Record< string, string > = {};

	// Font Size
	if ( values.fontSize ) {
		const fontSize = /[a-zA-Z%]/.test( values.fontSize )
			? values.fontSize
			: `${ values.fontSize }px`;
		styles[ 'font-size' ] = fontSize;
	}

	// Line Height
	if ( values.lineHeight ) {
		// Line height can be unitless or have units
		const lineHeight = /[a-zA-Z%]/.test( values.lineHeight )
			? values.lineHeight
			: values.lineHeight; // Keep unitless for line-height
		styles[ 'line-height' ] = lineHeight;
	}

	// Color
	if ( values.color ) {
		styles[ 'color' ] = values.color;
	}

	// Text Align
	if ( values.textAlign ) {
		styles[ 'text-align' ] = values.textAlign;
	}

	/**
	 * Filter typography CSS rules
	 *
	 * Allows modification of generated typography CSS rules
	 *
	 * @since 1.0.0
	 *
	 * @param {Record<string, string>} styles - Generated CSS rules
	 * @param {TypographyValues} values - Typography control values
	 */
	return applyFilters(
		'redfox_thank_you.typography.css_rules',
		styles,
		values,
	) as Record< string, string >;
};
